import { AppBottomTabs } from "@features/dashboard/layouts/AppBottomTabs";
import { AppDrawer } from "@features/dashboard/layouts/AppDrawer";
import { replayManager } from "@helpers/lib/sentry";
import { isWeb } from "@memorang/helpers/platform";
import { useDevice } from "@memorang/ui/useDevice";
import { CommandBarProviderWrapper } from "components/CommandBarProviderWrapper";
import { useFocusEffect } from "expo-router";
import { useCallback } from "react";

const DashboardLayout = () => {
	const { isMobile } = useDevice();

	useFocusEffect(
		useCallback(() => {
			replayManager().stopReplay();
		}, []),
	);

	return (
		<CommandBarProviderWrapper>
			{isMobile && !isWeb ? <AppBottomTabs /> : <AppDrawer />}
		</CommandBarProviderWrapper>
	);
};

export default DashboardLayout;
